class StayAISubscriptions extends HTMLElement {
  static get observedAttributes() {
    return ["data-subscription-widget", "data-subscription-style"];
  }

  constructor() {
    super();

    this.attachShadow({ mode: "open" });

    this.retextionData = {
      retextionAppId: "5859381",
      product: {},
      currentVariant: {},
      sellingPlanGroups: [],
      show_purchase_options: true,
      purchase_type_label: "Purchase Type",
      frequency_heading: "Frequency",
      one_time_purchase_label: "One Time Purchase",
      subscription_label: "Subscribe & Save",
      default_to_subscription: false,
      default_to_subscription_on_variant_change: false,
      frequencyVisible: true,
      show_subscription_details: true,
      icon_path:
        "<svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' ><path fill='currentColor' d='M13.64 2.35C12.19 0.9 10.2 0 7.99 0C3.57 0 0 3.58 0 8C0 12.42 3.57 16 7.99 16C11.72 16 14.83 13.45 15.72 10H13.64C12.82 12.33 10.6 14 7.99 14C4.68 14 1.99 11.31 1.99 8C1.99 4.69 4.68 2 7.99 2C9.65 2 11.13 2.69 12.21 3.78L8.99 7H15.99V0L13.64 2.35Z'></path></svg>",
      subscription_details_box_button_text: "Subscription Details",
      subscription_details_box_title: "How subscriptions work",
      subscription_details_box_content:
        "Products are automatically delivered on your schedule. No obligation, modify or cancel your subscription anytime.",
      requiresPlan: false,
      productFormId: "form[action='/cart/add']",
    };
    this.previousRetextionData = {};
    this.subscriptionWidget = null;
    this.purchaseTypeOneTime = null;
    this.purchaseTypeSubscription = null;
    this.radioOneTime = null;
    this.radioSubscription = null;
    this.subscriptionBox = null;
    this.sellingPlanSelector = null;

    this.shadowRoot.innerHTML = `
      <div class="stay-ai-subscriptions is-visible">
        <span class="purchaseTypeLbl" style="display: none"></span>
        
        <div data-rtx-subscription class="rtx-subscription">
          <div class="widget">
            <label for="purchaseTypeSubscription" class="rtx-purchase-label" >
              <div class="purchase-label">
                <div class="rtx-purchase-label__inner">
                  <input type="radio" id="purchaseTypeSubscription" name="purchaseType" value="purchaseTypeSubscription" />
                  <span class="subscription-label"></span>
                  <span class="subscription-savings" style="display:none;"></span>
                </div>
                <span data-rtx-subscription-price></span>
              </div>
              
              <div data-retextion-subscription-box class="rtx-subscription-box">
                <span class="frequency-heading" style="display: none"></span>
                <div class="heading-icon">
                  <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="35" y="1.5299e-06" width="35" height="35" rx="17.5" transform="rotate(90 35 1.5299e-06)" fill="#202020"/>
                  <path d="M20.9163 18.2767C20.9181 17.7384 20.9151 17.1982 20.9163 16.6599L22.3125 16.6599L22.3125 18.2767C21.8479 18.2779 21.3809 18.2748 20.9163 18.2767C20.9145 18.8048 20.9282 19.3354 20.9032 19.8636C20.8818 19.8959 20.8456 19.8908 20.8135 19.8946C20.4588 19.9403 19.9265 19.8934 19.5498 19.8934C19.548 20.4209 19.551 20.9509 19.5498 21.4784L18.2278 21.4784L18.1833 21.5259L18.1833 23L16.8167 23C16.8167 22.4934 16.8167 21.985 16.8167 21.4784C17.2719 21.479 17.7281 21.4784 18.1833 21.4784L18.1833 19.8934L16.8613 19.8934C16.8191 19.9213 16.8203 19.9568 16.815 20.0024C16.7692 20.419 16.8162 21.0371 16.8167 21.4784C16.3717 21.4778 15.9249 21.4784 15.4799 21.4784L15.4799 19.8934L16.7722 19.8934L16.8167 19.8458L16.8167 12L18.0941 12L18.1874 19.8414L18.2112 19.8794C18.6544 19.9048 19.1048 19.8934 19.5498 19.8934C19.5516 19.3551 19.5486 18.8149 19.5498 18.2767C20.0049 18.2754 20.4612 18.2786 20.9163 18.2767Z" fill="white"/>
                  <path d="M14.1135 18.2766C14.5686 18.2779 15.0249 18.2754 15.48 18.2766L15.48 19.8458L15.4354 19.8933L14.1135 19.8933C14.1129 19.3551 14.1147 18.8149 14.1135 18.2766C13.6388 18.2754 13.1623 18.2779 12.6875 18.2766L12.6875 16.6599L14.1135 16.6599C14.1141 17.1982 14.1123 17.7384 14.1135 18.2766Z" fill="white"/>
                  </svg>
                </div>
                
                <select class="rtx-subscription-dropdown" name="rtx_selling_plan">
                  <option value="">Select frequency</option>
                </select>
              </div>
              
              <span class="subscription-info">
                <ul>
                  <li>Free shipping on orders $55+</li>
                  <li>VIP discounts & early access</li>
                  <li>Pause, edit, or cancel anytime</li>
                </ul>
              </span>
            </label>
            
            <label for="purchaseTypeOneTime" class="rtx-purchase-label is-selected">
              <div class="purchase-label">
                <div class="rtx-purchase-label__inner">
                  <input type="radio" id="purchaseTypeOneTime" name="purchaseType" value="purchaseTypeOneTime" checked />
                  <span class="one-time-purchase-label"></span>
                </div>
                <span data-rtx-onetime-price></span>
              </div>
            </label>
          </div>

          <div class="rtx-subscription-details-box" style="display: none">
            <button type="button" class="rtx-modal-button" data-rtx-modal-open>
              <span class="icon-container"></span>
              <span class="subscription-details-button-text"></span>
            </button>
            <div class="rtx-modal" data-rtx-modal>
              <div class="rtx-modal__content">
                <span class="subscription-details-title"></span>
                <p class="subscription-details-content"></p>
              </div>
            </div>
          </div>
        </div>
      </div>      
    `;
  }

  // Called when the data-subscription-widget attribute changes
  attributeChangedCallback(name, oldValue, newValue) {
    if (this.subscriptionBox == null) {
      this.subscriptionWidget = this.shadowRoot.querySelector(
        `.stay-ai-subscriptions`
      );
      this.purchaseTypeOneTime = this.shadowRoot.querySelector(
        '[for="purchaseTypeOneTime"]'
      );
      this.purchaseTypeSubscription = this.shadowRoot.querySelector(
        '[for="purchaseTypeSubscription"]'
      );
      this.radioOneTime = this.shadowRoot.querySelector(
        '[value="purchaseTypeOneTime"]'
      );
      this.radioSubscription = this.shadowRoot.querySelector(
        '[value="purchaseTypeSubscription"]'
      );
      this.subscriptionBox = this.shadowRoot.querySelector(
        "[data-retextion-subscription-box]"
      );
      this.sellingPlanSelector = this.shadowRoot.querySelector(
        ".rtx-subscription-dropdown"
      );
      this.subscriptionDetailsBox = this.shadowRoot.querySelector(
        ".rtx-subscription-details-box"
      );
    }

    if (name === "data-subscription-widget" && newValue) {
      // Skip processing if value hasn't changed.
      if (
        this.previousRetextionData &&
        JSON.stringify(this.previousRetextionData) === JSON.stringify(newValue)
      )
        return;

      let newData = JSON.parse(newValue);
      this.updateWidgetIfChanged(newData);
      // Initialize event listeners
      this.setupEventListeners();
    }

    // Apply styles if the data-subscription-style attribute changes
    if (name === "data-subscription-style" && newValue) {
      let newStyle = JSON.parse(newValue);
      this.applyStyles(newStyle);
    }
  }

  updateWidgetIfChanged(newData) {
    // Only update the widget if the value has changed from the previous data
    if (JSON.stringify(this.previousRetextionData) === JSON.stringify(newData))
      return;

    this.retextionData = { ...newData };

    this.updateTextContent(
      ".purchaseTypeLbl",
      this.retextionData.purchase_type_label,
      this.previousRetextionData.purchase_type_label
    );
    this.updateTextContent(
      ".one-time-purchase-label",
      this.retextionData.one_time_purchase_label,
      this.previousRetextionData.one_time_purchase_label
    );
    this.updateTextContent(
      ".subscription-label",
      this.retextionData.subscription_label,
      this.previousRetextionData.subscription_label
    );
    this.updateTextContent(
      ".icon-container",
      this.retextionData.icon_path,
      this.previousRetextionData.icon_path
    );
    this.updateTextContent(
      ".subscription-details-button-text",
      this.retextionData.subscription_details_box_button_text,
      this.previousRetextionData.subscription_details_box_button_text
    );
    this.updateTextContent(
      ".subscription-details-content",
      this.retextionData.subscription_details_box_content,
      this.previousRetextionData.subscription_details_box_content
    );
    this.updateTextContent(
      ".frequency-heading",
      this.retextionData.frequency_heading,
      this.previousRetextionData.frequency_heading
    );

    // Custom subscription benefit bullets (per-template via block settings)
    const benefitsList = this.shadowRoot.querySelector(".subscription-info ul");
    if (benefitsList && Array.isArray(this.retextionData.subscription_benefits)) {
      const benefits = this.retextionData.subscription_benefits
        .map((text) => String(text).trim())
        .filter(Boolean);
      if (benefits.length) {
        benefitsList.replaceChildren(
          ...benefits.map((text) => {
            const li = document.createElement("li");
            li.textContent = text;
            return li;
          })
        );
      }
    }

    // Show or hide the subscription details box
    this.subscriptionDetailsBox.classList.toggle(
      "hidden",
      !this.retextionData.show_subscription_details
    );

    if (
      this.retextionData.default_to_subscription !==
      this.previousRetextionData.default_to_subscription
    ) {
      const isDefaultToSubscription =
        this.retextionData.default_to_subscription;
      const isSubscriptionSelected = this.isSubscriptionOptionSelected();

      if (isDefaultToSubscription !== isSubscriptionSelected) {
        this.purchaseTypeOneTime.classList.toggle("is-selected", !isDefaultToSubscription);
        this.purchaseTypeSubscription.classList.toggle("is-selected", isDefaultToSubscription);
        this.toggleRadioButtons();
      }
    }

    // Populate the frequency selector with selling plans if available
    const hasVariantChanged =
      this.retextionData.currentVariant &&
      this.previousRetextionData.currentVariant !==
        this.retextionData.currentVariant;

    const hasSellingPlans =
      this.retextionData.currentVariant?.selling_plan_allocations.length > 0;
    if (hasVariantChanged && hasSellingPlans) {
      if (this.retextionData.requiresPlan) {
        this.purchaseTypeOneTime.style.display = 'none';
      } else {
        this.purchaseTypeOneTime.style.display = 'flex';
      }
      this.subscriptionWidget.classList.toggle("is-visible", true);
      this.updateSellingPlans();
    } else {
      console.log("No SPs, hiding widget");
      this.subscriptionWidget.classList.toggle("is-visible", false);
      this.updateSellingPlanInput("");

      const productFormId = this.retextionData.productFormId;
      window._rtxPriceState = window._rtxPriceState || {};
      window._rtxPriceState[productFormId] = { type: "hidden", productFormId };
      document.dispatchEvent(
        new CustomEvent("rtx:widget-hidden", { detail: { productFormId } })
      );
    }

    //Update data
    this.previousRetextionData = { ...newData };
  }

  //Update content
  updateTextContent(selector, newValue, oldValue) {
    const element = this.shadowRoot.querySelector(selector);
    if (newValue !== oldValue && element) {
      element.innerHTML = newValue;
    }
  }

  // Set up event listeners for the purchase type, frequency and variant selectors
  setupEventListeners() {
    const purchaseTypeRadioButtons = this.shadowRoot.querySelectorAll(
      'input[name="purchaseType"]'
    );
    const variantSelectors = document.querySelectorAll('[name="id"]');

    // Handle purchase type change
    purchaseTypeRadioButtons.forEach((radio) =>
      radio.addEventListener("change", () => {
        this[
          radio.value === "purchaseTypeSubscription"
            ? "showSubscriptionBox"
            : "hideSubscriptionBox"
        ]();
        this.updateProductPrice(this.sellingPlanSelector.value);
      })
    );

    // Handle frequency selector change
    this.sellingPlanSelector.addEventListener("change", (e) => {
      this.updateSellingPlanInput(e.target.value);
      this.updateProductPrice(e.target.value);
    });

    // Handle variant change
    variantSelectors.forEach((selector) =>
      selector.addEventListener("change", ({ target }) => {
        const variantId = Number(target.value);
        this.retextionData.currentVariant =
          this.retextionData.product.variants.find((v) => v.id === variantId);
        this.updateWidgetIfChanged(this.retextionData);
      })
    );
  }

  // Populate the subscription frequency selector with selling plans for the current variant
  updateSellingPlans() {
    const { currentVariant, sellingPlanGroups } = this.retextionData;

    // Get the selling plans for the current variant
    const sellingPlans = currentVariant.selling_plan_allocations
      .map((spa) =>
        sellingPlanGroups
          .find((g) => g.id === spa.selling_plan_group_id)
          ?.selling_plans.find((sp) => sp.id === spa.selling_plan_id)
      )
      .filter(Boolean);

    // Clear existing options and populate dropdown
    this.sellingPlanSelector.innerHTML = sellingPlans
      .map(
        (plan) => `<option value="${plan.id}">${plan.options[0].value}</option>`
      )
      .join("");

    const hasSubscription = this.isSubscriptionOptionSelected();

    if (!hasSubscription) {
      this.addSelectFrequencyOption();
      this.updateSellingPlanInput("");
    } else {
      this.updateSellingPlanInput(sellingPlans[0]?.id || "");
    }

    // Show or hide the subscription frequency selector
    this.subscriptionBox.classList.toggle("is-visible", hasSubscription);

    // Update prices
    this.updateProductPrice(
      hasSubscription
        ? this.sellingPlanSelector.value
        : sellingPlans[0]?.id || ""
    );
  }

  addSelectFrequencyOption() {
    if (!this.sellingPlanSelector.querySelector('option[value=""]')) {
      this.sellingPlanSelector.insertAdjacentHTML(
        "afterbegin",
        '<option value="" selected>Select frequency</option>'
      );
    }
  }

  showSubscriptionBox() {
    this.subscriptionBox.classList.toggle("disable", false);
    this.subscriptionBox.classList.toggle("is-visible", true);
    this.purchaseTypeSubscription.classList.toggle("is-selected", true);
    this.purchaseTypeOneTime.classList.toggle("is-selected", false);

    // Remove "Select frequency" option
    this.sellingPlanSelector.querySelector('option[value=""]')?.remove();
    this.updateSellingPlanInput(this.sellingPlanSelector.value);
  }

  // Hide the subscription frequency selector
  hideSubscriptionBox() {
    if (!this.frequencyVisible) {
      this.subscriptionBox.classList.toggle("is-visible", false);
    }

    this.addSelectFrequencyOption();
    this.subscriptionBox.classList.toggle("disable", false);
    this.purchaseTypeSubscription.classList.toggle("is-selected", false);
    this.purchaseTypeOneTime.classList.toggle("is-selected", true);
    this.updateSellingPlanInput("");
  }

  // Check if the subscription option is selected
  isSubscriptionOptionSelected() {
    return this.purchaseTypeSubscription.classList.contains("is-selected");
  }

  //Add selling plan input to form with specified selling plan ID
  updateSellingPlanInput(sellingPlanId) {
    const productForm = document.querySelector(
      this.retextionData.productFormId?.trim()
        ? `#${this.retextionData.productFormId}`
        : `form[action='/cart/add'][data-type='add-to-cart-form']`
    );

    if (!productForm) return;

    // Find or create the hidden input for selling plan
    let sellingPlanInput = productForm.querySelector(
      "input[name='selling_plan']"
    );
    if (!sellingPlanInput) {
      sellingPlanInput = document.createElement("input");
      sellingPlanInput.type = "hidden";
      sellingPlanInput.name = "selling_plan";
      sellingPlanInput.value = sellingPlanId;
      productForm.appendChild(sellingPlanInput);
    } else {
      sellingPlanInput.value = sellingPlanId;
    }
  }

  updateProductPrice(sellingPlanId) {
    const { currentVariant, sellingPlanGroups } = this.retextionData;

    const selectedSellingPlanAllocation =
      currentVariant.selling_plan_allocations.find(
        (spa) => spa.selling_plan_id == sellingPlanId
      );

    const sellingPlan = sellingPlanGroups
      .find((group) => group.selling_plans.some((sp) => sp.id == sellingPlanId))
      ?.selling_plans.find((sp) => sp.id == sellingPlanId);

    const oneTimeLblPrice = this.shadowRoot.querySelector(
      "[data-rtx-onetime-price]"
    );
    const subscriptionLblPrice = this.shadowRoot.querySelector(
      "[data-rtx-subscription-price]"
    );
    const savingLbl = this.shadowRoot.querySelector(".subscription-savings");

    const onetimePrice = this.formatMoney(currentVariant.price);
    let subscriptionPrice = onetimePrice;
    let savingsLabel = "";

    // Update one-time price if necessary
    if (oneTimeLblPrice && oneTimeLblPrice.textContent !== onetimePrice) {
      oneTimeLblPrice.textContent = onetimePrice;
    }

    // Update subscription price
    if (selectedSellingPlanAllocation) {
      subscriptionPrice = this.formatMoney(selectedSellingPlanAllocation.price);

      if (
        subscriptionLblPrice &&
        subscriptionPrice !== subscriptionLblPrice.textContent
      ) {
        subscriptionLblPrice.innerHTML =
          subscriptionPrice !== onetimePrice
            ? `<s class="fullPrice">${onetimePrice}</s>${subscriptionPrice}`
            : subscriptionPrice;
      }

      // Calculate and update savings label
      let discount = currentVariant.price - selectedSellingPlanAllocation.price;

      if (discount > 0) {
        if (sellingPlan?.price_adjustments[0].value_type === "percentage") {
          discount = `${sellingPlan.price_adjustments[0].value}%`;
        } else {
          discount = this.formatMoney(discount);
        }
        savingsLabel = `Save ${discount}`;
        if (savingLbl.textContent !== discount)
          savingLbl.textContent = savingsLabel;
          savingLbl.style.display = 'flex';
      } else {
        savingLbl.textContent = "";
        savingLbl.style.display = 'none';
      }
    }

    // Dispatch price update event for external listeners (button, price block)
    const detail = {
      productFormId: this.retextionData.productFormId,
      isSubscription: this.isSubscriptionOptionSelected(),
      subscriptionPrice,
      onetimePrice,
      savingsLabel,
    };
    window._rtxPriceState = window._rtxPriceState || {};
    window._rtxPriceState[this.retextionData.productFormId] = { type: "update", detail };
    document.dispatchEvent(new CustomEvent("rtx:price-update", { detail }));
  }

  // Toggle checked state based on the currently checked radio button
  toggleRadioButtons() {
    this.radioOneTime.checked = !this.radioOneTime.checked;
    this.radioSubscription.checked = !this.radioSubscription.checked;
  }

  // Format money based on Shopify's active currency
  formatMoney(money) {
    const currencySymbols = {
      USD: "$",
      EUR: "€",
      GBP: "£",
      JPY: "¥",
      CAD: "C$",
      AUD: "A$",
      CHF: "CHF",
      CNY: "¥",
      SEK: "kr",
      NZD: "NZ$",
    };

    const activeCurrency = Shopify.currency.active;
    const currencySymbol = currencySymbols[activeCurrency] || activeCurrency;
    const formattedMoney = (money / 100).toFixed(2);
    var formatted;

    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
        formatted = window.Shopify.formatMoney(money);
        if (formatted) return formatted;
      }

      if (
        window.theme &&
        window.theme.utils &&
        typeof window.theme.utils.formatMoney === "function"
      ) {
        formatted = theme.utils.formatMoney(money);
        if (formatted) return formatted;
      }
      return `${currencySymbol}${formattedMoney}`;
    } catch (error) {
      console.error("Error formatting money:", error);
      return `${currencySymbols["USD"]}${formattedMoney}`;
    }
  }

  // Apply styles to the widget
  applyStyles(settings) {
    const style = document.createElement("style");

    //Widget layout
    let layoutCSS = "";
    if (settings.widget_layout === "stacked-buttons") {
      layoutCSS = `.rtx-purchase-label input{
          display: none!important;
        }`;
    } else if (settings.widget_layout === "side-by-side-buttons") {
      layoutCSS = `.widget{
                    align-items: center;
                    flex-direction: row;
                    gap:10px;
                }
                .purchase-label{
                    flex-direction: column;
                    align-items: center;
                }
                .rtx-purchase-label input{
                  display: none!important;
                }
                .rtx-purchase-label__inner{
                  margin-bottom: 0px;
                }
                `;
    }
    if (settings.subscription_label_first) {
      layoutCSS += `.rtx-purchase-label:last-of-type{
            order: 1;
        }
        .rtx-purchase-label:first-of-type{
            order: 2;
        }`;
    }

    style.textContent = `
      :host {
        --text-color: ${settings.textColor};
        --font-family: ${settings.fontFamily};
        --font-size: ${settings.fontSize};
        --border-radius: ${settings.borderRadius};
        --border-width: ${settings.borderWidth};
        --border-color: ${settings.borderColor};
        --selected-text-color: ${settings.selectedTextColor};
        --bg-color: ${settings.bgColor};
        --selected-bg-color: ${settings.selectedBgColor};
        --accent-color: ${settings.accentColor};
      }
        .stay-ai-subscriptions {
            display: none;
        }
        .stay-ai-subscriptions.is-visible {
            display: block;
        }
        .purchaseTypeLbl, .frequency-heading{
            font-family: 'Minimo', sans-serif;
            color: var(--text-color)!important;
            text-transform: uppercase;
            font-weight: 700;
            font-size:14px;
        }
        
        .rtx-subscription,.rtx-subcription * {
            box-sizing: border-box;
            color: var(--text-color)!important;
            font-family: var(--font-family)!important;
            font-size: var(--font-size)!important;
        }
        
        .rtx-subscription {
            display: flex;
            flex-direction: column;
            grid-row-gap: 10px;
        }
        
        .widget {
            display: flex;
            flex-direction: column;
            grid-row-gap: 10px;
        }
        
        /* Widget layout */
        ${layoutCSS}
        
        /* Purchase labels */        
        .rtx-subscription label {
            box-sizing: border-box;
            cursor: pointer;
            
            opacity: 0.3;
            color: #202020;
            padding: 22px 25px;
            background: #F1F1F1;
            border-radius: 20px;
            border: 1px solid #202020;
            transition: all .3s ease-in-out;
            
            display: flex;
            grid-row-gap: 15px;
            flex-direction: column;
        }
        
        .rtx-subscription label *,
        .rtx-subscription label *:after,
        .rtx-subscription label *:before {
            box-sizing: border-box;
        }
        
        .rtx-subscription label.is-selected {
            opacity: 1;
        }
        
        .rtx-subscription label.is-selected input {
            accent-color: #202020;
        }
        
        .rtx-subscription .purchase-label {
            display: flex;
            grid-row-gap: 5px;
            grid-column-gap: 5px;
            align-items: flex-start;
            justify-content: space-between;
        }
        
        .rtx-purchase-label__inner {
            cursor: pointer;
            
            gap: 5px;
            display: flex;
            align-items: center;
            justify-content: flex-start;
        }
        
        .rtx-purchase-label .input-wrap {
            position: relative;
        } 
        
        .rtx-purchase-label input {
            margin: 0;
            width: 16px;
            height: 16px;
            transition: all .3s ease-in-out;
            accent-color: rgba(32, 32, 32, 0.2);
        }
        
        .rtx-purchase-label .subscription-label,
        .rtx-purchase-label .one-time-purchase-label {
            font-family: 'px-light', sans-serif;
            font-weight: 300;
            font-size: 18px;
            line-height: 1.3;
            color: #202020;
        }
        
        .rtx-purchase-label .subscription-savings {
            padding: 4px 10px;
            min-height: 23px;
            background: #FF8C34;
            border-radius: 77px;
            
            display: flex;
            align-items: center;
            text-align: center;
            justify-content: center;
            
            font-family: 'px-screen', sans-serif;
            text-transform: uppercase;
            font-weight: 800;
            font-size: 10px;
            line-height: 1;
            color: #ffffff;
        }
        
        .rtx-purchase-label .subscription-info {
            display: none;
            margin: 0;
            
            font-family: "px-light", "sans-serif";
            font-weight: 300;
            font-size: 16px;
            line-height: 1.3;
            color: #202020;
        }
        
        .rtx-purchase-label.is-selected .subscription-info {
            display: block;
        }
        
        .rtx-purchase-label .subscription-info ul {
            margin: 0;
            padding: 0;
            list-style: none;
        }
        
        .rtx-purchase-label .subscription-info ul li {
            padding-left: 25px;
            position: relative;
        }
        
        .rtx-purchase-label .subscription-info ul li + li {
            margin: 5px 0 0;
        }
       
        .rtx-purchase-label .subscription-info ul li:before {
            content: '+';
            position: absolute;
            top: 2px;
            left: 0;
          
            width: 16px;
            height: 16px;
            min-width: 16px;
            overflow: hidden;
            padding: 0 0 1px 1px;
            border-radius: 100%;
            background: #202020;
            
            font-family: "px-light", "sans-serif";
            font-weight: 300;
            font-size: 16px;
            line-height: 1;
            color: #ffffff;
            
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
        }
        
        [data-rtx-subscription-price=''] {
            display: flex;
            grid-row-gap: 7px;
            text-align: right;
            align-items: flex-end;
            flex-direction: column-reverse;
            
            font-family: 'px-screen', sans-serif;
            font-weight: 800;
            font-size: 20px;
            line-height: 1;
            color: #202020;
            letter-spacing: 0.44px;
        }
        
        [data-rtx-subscription-price=''] s {
            opacity: 65%;
            font-size: 13px;
            letter-spacing: 0.16px;
        }
        
        .is-selected [data-rtx-subscription-price=''] s{
          color: var(--selected-text-color);
        }

        /* Display compare at price */
        ${settings.display_compare_at_price ? "" : "[data-rtx-subscription-price=''] s{display:none;}"}

        /* Display compare at price position */
        ${settings.compare_at_price_first ? ""
            : "[data-rtx-subscription-price='']{flex-direction: row-reverse;}[data-rtx-subscription-price='']{justify-content: flex-start;}"
        }

        /* Subscription box that displays the frequency selector */
        ${settings.frequencyVisible ? "" : ".rtx-subscription-box{display:none}"}
        
        .rtx-subscription-box.is-visible {
            display: flex;
            flex-wrap: wrap;
            grid-row-gap: 5px;
            align-items: center;
            grid-column-gap: 5px;
        }  
        
        .rtx-purchase-label .rtx-subscription-box {
            position: relative;
        }
        
        .rtx-purchase-label .heading-icon {
            position: absolute;
            right: 4px;
            top: 50%;
            z-index: 1;
            transform: translateY(-50%);
            
            display: flex;
            align-items: center;
            justify-content: center;
            
            width: 25px;
            height: 25px;
            min-width: 25px;
        }
        
        .rtx-purchase-label select[name='rtx_selling_plan']{
            font-family: px-light, sans-serif;
            color: var(--color-black-2);
            font-weight: 300;
            font-size: 14px;
            line-height: 1.4;
            
            outline: none;
            width: 100%;
            cursor: pointer;
            min-height: 32px;
            padding: 8px 16px;
            position: relative;
            border-radius: 20px;
            background: #ffffff;
            border: 1px solid #202020;
            transition: all .3s ease-in-out;
            
            display: flex;
            text-align: center;
            align-items: center;
            justify-content: center;
        }
        
        .hidden {
            display: none;
        }    

        /* Subscription Detail Box */
        .rtx-modal-button {
            padding: 0;
            font-size: 16px;
            background: none;
            border: none;
            text-transform: initial;
            height: auto;
            min-height: 0;
            margin-left: 0px;
            cursor: pointer;
            margin-top: 10px;
            color: var(--text_color);
            font-family: var(--font-family) !important;
            font-size: var(--font-size) !important;
        }

        /* Modal content */
        .rtx-modal__content {
            position: absolute;
            z-index: 5;
            background: white;
            width: auto;
            max-width: 25rem;
            overflow-x: hidden;
            padding: 1rem 2rem;
            font-size: 15px;
            transform: translateY(-1rem);
            margin-top: 5px;
            margin-left: 12px;
            display: none;
            opacity: 0;
            transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
            box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.12),
                        0px 1px 2px 0px rgba(0, 0, 0, 0.24);
        }

        /* Modal container */
        .rtx-modal {
            z-index: 5;
            opacity: 0;
            visibility: hidden;
            transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;
        }

        /* Hover effect for button and showing modal content */
        .rtx-modal-button:hover ~ .rtx-modal {
            opacity: 1;
            visibility: visible;
            transition: opacity 0.3s ease-out, visibility 0.3s ease-out;
        }

        .rtx-modal-button:hover + .rtx-modal .rtx-modal__content {
            display: block;
            opacity: 1;
            transform: translateY(0);
        }
        
        .disable {
          pointer-events: none;
          cursor: none;
          opacity: 0.5;
        }
        
        @media (max-width: 1199px) {
          .rtx-subscription label {
              padding: 20px 15px;
          }
        }
        
        @media (max-width: 600px) {
         .widget {   
           flex-direction: column;
         }
         
         .rtx-modal__content {
              max-width: 90%;
              padding: 1rem;
              font-size: 16px;
          }
        }
        
        @media (max-width: 389px) {
          .rtx-purchase-label .subscription-label,
          .rtx-purchase-label .one-time-purchase-label {
             font-size: 16px;
          }
        }
    `;

    // Append the style element to the shadow root
    this.shadowRoot.appendChild(style);
  }
}

// Define the custom element
customElements.define("purchase-options", StayAISubscriptions);
